import PropTypes from 'prop-types';
import Button from "components/ui/Button/Button";
import { ReactComponent as IconPencil } from "assets/images/icons/pencil-square-primary.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/trashfull.svg";
import { useDialog } from "context/DialogContext";
import GroupCreateUpdate from "features/groups/components/GroupCreateUpdate";
import GroupDelete from "features/groups/components/GroupDelete";

const GroupOwnerButtons = ({ nid, title, onEdited, onDeleted }) => {
  const { showDialog } = useDialog();
  return (
    <>
      <Button variant={ 'ghost' }
              onClick={ () => showDialog(<GroupCreateUpdate id={ nid }
                                                            onCompleted={ onEdited }/>) }
              className={ 'button--small' }>
        <IconPencil/>
        Groep bewerken
      </Button>

      <Button variant={ 'ghost' }
              onClick={ () => showDialog(<GroupDelete/>) }
              className={ 'button--small' }>
        <IconTrash/>
        Groep verwijderen
      </Button>
    </>
  )
}

GroupOwnerButtons.propTypes = {
  nid: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onDeleted: PropTypes.func.isRequired,
  onEdited: PropTypes.func.isRequired,
}

export default GroupOwnerButtons;
